import React, { Component } from 'react';
import { withRouter } from '../withRouter';
import { ItemLookupInfo } from './InventoryManagement/componentChildren/ItemLookupInfo';
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';
import './InventoryManagement/css/inventoryManagement.css';
import { ItemLookupSublocationManagement } from './InventoryManagement/componentChildren/ItemLookupSublocationManagement';
import { ItemSearch } from './InventoryManagement/componentChildren/ItemSearch';

class ItemLookup extends Component {
    constructor(props) {
        super(props);
        const linkedItemUPC = this.props.location?.state?.upccode;
        this.state = {
            selectedView: "stock",
            userInput: linkedItemUPC,
            sublocationInput: "",
            stkInfoId: null,
            maxCapacity: null,
            preferred: null,
            sublocationActionHeader: null,
            sublocationMethod: null,
            sublocationButton: null,
            newSublocation: null,
            sublocationSearchResults: [],
            itemInfo: [],
            imageURLs: [],
            inventoryInfo: [],
            sublocationInfo: [],
            siblingsInfo: [],
            itemId: "",
            itemName: "",
            itemType: "",
            onHandQty: 0,
            label: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: linkedItemUPC ? true : false
        };
        this.resetState = this.resetState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.lookupItemInfo = this.lookupItemInfo.bind(this);
        this.lookupItemInfoCallback = this.lookupItemInfoCallback.bind(this);
        this.handleViewChange = this.handleViewChange.bind(this);
        this.lookupSibling = this.lookupSibling.bind(this);
        this.printTag = this.printTag.bind(this);
        this.viewImage = this.viewImage.bind(this);
        this.moveItem = this.moveItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.removeItemCallback = this.removeItemCallback.bind(this);
        this.printTagCallback = this.printTagCallback.bind(this);
        this.getAdditionalStockInfo = this.getAdditionalStockInfo.bind(this);
        this.addSublocation = this.addSublocation.bind(this);
        this.cancelSublocationUpdate = this.cancelSublocationUpdate.bind(this);
        this.findSublocation = this.findSublocation.bind(this);
        this.findSublocationCallback = this.findSublocationCallback.bind(this);
        this.selectSublocation = this.selectSublocation.bind(this);
        this.updateSublocation = this.updateSublocation.bind(this);
        this.updateSublocationCallback = this.updateSublocationCallback.bind(this);
        
        if (linkedItemUPC) {
           this.lookupItemInfo();
        }
    }

    componentDidMount() { 
        document.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                var upcInput = document.getElementById('upc-input');
                var sublocationInput = document.getElementById('subloc-input');
                if (sublocationInput) {
                    var submitButton = document.getElementById('sublocation-search-submit');
                    submitButton.click();
                }
                else if (upcInput) {
                    var submitButton = document.getElementById('item-lookup-submit');
                    submitButton.click();
                }
            }
        });
        this.focusOnInput();
    }

    componentWillUnmount() {
        document.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                var upcInput = document.getElementById('upc-input');
                var sublocationInput = document.getElementById('subloc-input');
                if (sublocationInput) {
                    var submitButton = document.getElementById('sublocation-search-submit');
                    submitButton.click();
                }
                else if (upcInput) {
                    var submitButton = document.getElementById('item-lookup-submit');
                    submitButton.click();
                }
            }
        });
    }

    resetState() {
        this.setState({
            selectedView: "stock",
            userInput: "",
            sublocationInput: "",
            stkInfoId: null,
            maxCapacity: null,
            preferred: null,
            sublocationActionHeader: null,
            sublocationMethod: null,
            sublocationButton: null,
            newSublocation: null,
            sublocationSearchResults: [],
            itemInfo: [],
            imageURLs: [],
            inventoryInfo: [],
            sublocationInfo: [],
            siblingsInfo: [],
            itemId: "",
            itemName: "",
            itemType: "",
            onHandQty: 0,
            label: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        });
        
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            isErrorMessage: false
        });
        this.focusOnInput();
    }

    focusOnInput() {
        if (!this.state.showDialog) {
            var inputField = document.getElementById('upc-input') || document.getElementById('subloc-input');
            inputField.focus();
        }
    }

    updateInputValue(field, inputValue) {
        this.setState({
            [field]: inputValue
        });
    }

    lookupItemInfo() {
        const userInput = this.state.userInput;
        if (!userInput) {
            return;
        }
        this.setState({
            loading: true
        });
        setTimeout(() => { this.lookupItemInfoCallback() });
    }

    

    moveItem(sublocationInfo) {
        console.log("MOVING ITEM", sublocationInfo)
        this.setState({
            stkInfoId: sublocationInfo.stkinfoid,
            sublocationActionHeader: (
                <>
                    <b>MOVE: {this.state.itemName}</b>
                    <br />
                    <b>FROM: {sublocationInfo.name}</b>
                    <br />
                </>
            ),
            sublocationMethod: "moveSublocation",
            sublocationButton: <button onClick={() => { this.updateSublocation() }}>Move Here</button>
        })
    }


    removeItem(sublocationInfo) {
        if (window.confirm("Are you sure you want to remove this item?")) {
            this.setState({
                loading: true
            });
            setTimeout(() => { this.removeItemCallback(sublocationInfo.stkinfoid) });
        }
    }

    removeItemCallback(stkInfoId) {
        var postBody = {
            stkInfoId: stkInfoId,
            itemId: this.state.itemId,
            removeSublocation: true
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (removeItemResponse) => {
                console.log(removeItemResponse);
                if (removeItemResponse.success) {
                    this.setState({
                        sublocationInfo: removeItemResponse.sublocationInfo
                    });
                }
                else {
                    alert("Item removal failed. Please try again");
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    getAdditionalStockInfo() {
        let maxCapacity = 0;
        let preferred = false;
        //Prompt the user for the max capacity and preferred status of the sublocation
        //Max capacity is a number, preferred is a boolean
        do {
            maxCapacity = prompt("Enter the maximum capacity of the sublocation", 0);
        } while (isNaN(maxCapacity) || maxCapacity < 0 || maxCapacity > 100000)
        let preferredResponse;
        do {
            preferredResponse = prompt("Is this a preferred sublocation? (y/n)").toLowerCase();
        } while (preferredResponse !== "y" && preferredResponse !== "n");

        preferred = preferredResponse === "y";
        this.setState({
            maxCapacity: maxCapacity,
            preferred: preferred
        });
    }

    addSublocation() {
        this.setState({
            stkInfoId: -1,
            sublocationActionHeader: (
                <>
                    <b>PLACING: {this.state.itemName} </b>
                </>
            ),
            sublocationMethod: "addSublocation",
            sublocationButton: <button onClick={() => { this.updateSublocation() }}>Place Item Here</button>
        })
    }

    findSublocation() {
        const searchString = this.state.sublocationInput;
        if (!searchString) {
            return;
        }
        this.setState({
            loading: true
        });
        setTimeout(() => { this.findSublocationCallback() });
    }

    findSublocationCallback() {
        const postBody = {
            findSublocation: true,
            searchString: this.state.sublocationInput
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (findSublocationResults) => {
                console.log(findSublocationResults);
                if (findSublocationResults.sublocationInfo.length > 0) {
                    let newSublocation;
                    if (findSublocationResults.sublocationInfo.length == 1) {
                        newSublocation = findSublocationResults.sublocationInfo[0].id;
                    }
                    this.setState({
                        sublocationSearchResults: findSublocationResults.sublocationInfo,
                        newSublocation: newSublocation,
                        sublocationInput: ""
                    });
                }
                else {
                    this.setState({
                        showDialog: true,
                        dialogTitle: "Sublocation Not Found",
                        dialogContent: "Sublocation not found. Please try again with a different search term.",
                        isErrorMessage: true,
                        sublocationInput: ""
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    selectSublocation(sublocationInfo) {
        this.setState({
            newSublocation: sublocationInfo.id
        });
    }

    cancelSublocationUpdate() {
        this.setState({
            stkInfoId: null,
            sublocationActionHeader: null,
            sublocationMethod: null,
            sublocationButton: null,
            sublocationSearchResults: [],
            sublocationInput: ""
        });
    }

    updateSublocation() {
        this.setState({
            loading: true
        });
        setTimeout(() => { this.updateSublocationCallback() });
    }

    updateSublocationCallback() {
        this.getAdditionalStockInfo();
        var postBody = {
            stkInfoId: this.state.stkInfoId,
            sublocationId: this.state.newSublocation,
            itemId: this.state.itemId,
            maxCapacity: this.state.maxCapacity,
            preferred: this.state.preferred,
            [this.state.sublocationMethod]: true
        }
        this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (updateSublocationResponse) => {
                console.log(updateSublocationResponse);
                if (updateSublocationResponse.success) {
                    this.setState({
                        sublocationInfo: updateSublocationResponse.sublocationInfo,
                        stkInfoId: null,
                        sublocationActionHeader: null,
                        sublocationMethod: null,
                        sublocationButton: null,
                        sublocationSearchResults: []
                    });
                }
                else {
                    this.setState({
                        showDialog: true,
                        dialogTitle: "Error Updating Sublocation",
                        dialogContent: updateSublocationResponse.message,
                        isErrorMessage: true
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false,
                    maxCapacity: null,
                    preferred: null
                });
            }
        );
    }

    handleViewChange(event) {
        this.setState({ selectedView: event.target.value });
    }

    lookupSibling(upc) {
        this.setState({
            loading: true,
            userInput: upc,
            selectedView: "stock"
        });
        setTimeout(() => { this.lookupItemInfoCallback() });
    }

    printTag() {
        this.setState({
            loading: true
        });
        setTimeout(() => { this.printTagCallback() });
    }

    viewImage(event, itemName, imageUrl) {
        event.preventDefault();
        this.setState({
            showDialog: true,
            dialogTitle: itemName,
            dialogContent: <img src={imageUrl} alt={itemName} style={{ width: '300px', height: '300px', objectFit: 'cover' }} />,
            dialogFullScreen: true
        })
    }

    async printTagCallback() {
        var postBody = {
            printTag: true,
            itemId: this.state.itemId,
            label: this.state.label,
            itemType: this.state.itemType
        }
        await this.props.makeRESTCall(
            'byuinventorymanagement',
            'post',
            postBody,
            (printTagResponse) => {
                console.log(printTagResponse);
                if (printTagResponse.success) {
                }
                else {
                    alert("Tag print failed. Please try again");
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    async lookupItemInfoCallback() {
        await this.props.makeRESTCall(
            'byuinventorymanagement?itemIdentifier=' + this.state.userInput,
            'get',
            null,
            (itemLookupInfo) => {
                console.log(itemLookupInfo);
                if (itemLookupInfo.foundItem) {
                    this.setState({
                        userInput: "",
                        itemInfo: itemLookupInfo.itemInfo,
                        inventoryInfo: itemLookupInfo.inventoryInfo,
                        imageURLs: itemLookupInfo.imageURLs,
                        sublocationInfo: itemLookupInfo.sublocationInfo,
                        siblingsInfo: itemLookupInfo.siblingsInfo,
                        itemId: itemLookupInfo.itemId,
                        itemName: itemLookupInfo.itemName,
                        itemType: itemLookupInfo.itemType,
                        onHandQty: itemLookupInfo.onHandQty,
                        label: itemLookupInfo.label
                    });
                }
                else {
                    this.setState({
                        userInput: "",
                        showDialog: true,
                        dialogTitle: "Item Not Found",
                        dialogContent: "Item not found. Please try again with a different UPC.",
                        isErrorMessage: true
                    })
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }


    render() {
        return (
            <div className="itemLookup">
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                {
                    this.state.stkInfoId
                        ?
                        <ItemLookupSublocationManagement
                            sublocationSearchResults={this.state.sublocationSearchResults}
                            updateInputValue={this.updateInputValue}
                            sublocationInput={this.state.sublocationInput}
                            focusOnInput={this.focusOnInput}
                            findSublocation={this.findSublocation}
                            selectSublocation={this.selectSublocation}
                            cancelSublocationUpdate={this.cancelSublocationUpdate}
                            sublocationButton={this.state.sublocationButton}
                            itemName={ this.state.itemName }
                            sublocationActionHeader={this.state.sublocationActionHeader}
                            newSublocation={this.state.newSublocation}
                        />
                        :
                        <div>
                            <div>
                                {
                                    this.state.itemInfo.length > 0 ?
                                    <div class="item-lookup-buttons">
                                        <button onClick={() => { this.printTag() }}>Print Tag</button>
                                        <button onClick={() => { this.addSublocation() }}>Add Sub-Location</button>
                                    </div>
                                    :
                                    <div className="page-title">
                                        <h3>Item Lookup</h3>
                                        <br />
                                    </div>
                                }
                                <ItemSearch
                                    userInput={this.state.userInput}
                                    updateInputValue={this.updateInputValue}
                                    focusOnInput={this.focusOnInput}
                                    lookupItemInfo={this.lookupItemInfo}
                                    addingItem={false}
                                />
                            </div>
                            {
                                this.state.itemInfo.length > 0 &&
                                <div>
                                    <ItemLookupInfo
                                        imageURLs={this.state.imageURLs}
                                        itemInfo={this.state.itemInfo}
                                        itemName={this.state.itemName}
                                        inventoryInfo={this.state.inventoryInfo}
                                        sublocationInfo={this.state.sublocationInfo}
                                        siblingsInfo={this.state.siblingsInfo}
                                        onHandQty={this.state.onHandQty}
                                        moveItem={this.moveItem}
                                        removeItem={this.removeItem}
                                        handleViewChange={this.handleViewChange}
                                        lookupSibling={this.lookupSibling}
                                        selectedView={this.state.selectedView}
                                        viewImage={this.viewImage}
                                    />
                                </div>
                            }
                        </div>
                }
                
            </div>
        );
    }
}

export default withRouter(ItemLookup);
